import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ValidationLabel } from 'src/app/constants/labels';
import { ContainerSelectorComponent } from 'src/app/dialogs/container-selector/container-selector.component';
import { TypeGeneralResponseOption } from 'src/app/model/device/message.model';
import {
  Container,
  ContainerSelectorActions,
  ContainerSelectorEstructor,
} from 'src/app/model/http/container-selector.model';
import { UpdateProductUtility } from 'src/app/model/local/shopping-cart';
import { CalculationService } from 'src/app/services/calculation.service';
import { CommonService } from 'src/app/services/common.service';
import { DialogService } from 'src/app/services/dialog.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ObservableService } from 'src/app/services/observable.service';
import {
  BooleanCons,
  DontShowDetailButtonList,
  EstatusTypeCard,
  LineProductCons,
  NumberCons,
  RolesString,
  ShoppingCounter,
  StringConst,
} from '../../constants/const';
import { Messages } from '../../constants/messages';
import { UtilitiesCalculatorComponent } from '../../dialogs/utilities-calculator/utilities-calculator.component';
import { ICatalogs } from '../../model/http/catalogs';
import {
  CallCardProduct,
  CallPlace,
  ChangeFavorite,
  FavoriteChange,
  FavoriteConfig,
  IProducts,
  PiecesChangeEmitter,
  PricesPieces,
  ProductAttributes,
  UtilitiesCalculator,
} from '../../model/http/myActivity.model';
import { ProductUpdatedFavourite } from '../../model/http/shoppingList';
import { FavoritesService } from '../../services/favorites.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { v4 as uuidv4 } from 'uuid';
import { DetailProductsMock, MultiContainerProducsMock } from '../../../mocks/multicontainerProductMock';
import { ActivesPrinciplesValidation } from 'src/app/model/local/active.missing';
@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductCardComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() isNotOrderSap = BooleanCons.false;
  @Input() productCard: CallCardProduct = new CallCardProduct();
  @Input() isDiscountVisible = BooleanCons.false;
  @Input() promoCode = StringConst.empty;
  @Output() productEmitter = new EventEmitter<PiecesChangeEmitter>();
  @Output() piecesChangeEmitter = new EventEmitter<IProducts>();
  @Output() productEmitterUtilitiesCalculator =
    new EventEmitter<UtilitiesCalculator>();
  @Output() attributeDeleteEmitter = new EventEmitter<number>();
  @Input() configFavorite = new FavoriteConfig();
  @Input() configCardButton = new FavoriteConfig();
  @Input() showAddtoCarButton = BooleanCons.true;
  @Input() isContainerAndLabelEditable = BooleanCons.false;
  @Input() isUtility = BooleanCons.false;
  @Input() showFavoriteButton = BooleanCons.true;
  @Input() showDialogDiscount = BooleanCons.true;
  @Input() imgUrl = BooleanCons.false;
  @Input() isIncludeLabelDefault = BooleanCons.false;
  @Input() isNotStatusSap = BooleanCons.false;
  @Input() showIvaLegend = BooleanCons.false;
  @Input() showContainerDiscountNoButton = BooleanCons.false;
  @Input() showAsteriskPackages = BooleanCons.false;
  @Input() validateFavorite = BooleanCons.false;
  @Input() index = NumberCons.zero;
  @Input() showAddToSaveListShoppingCar = BooleanCons.false;
  @Input() showAddToListShoppingCar = BooleanCons.false;
  @Output() viewReady = new EventEmitter<void>();
  @Input() isLastItem = BooleanCons.false;
  @Input() typeCart = EstatusTypeCard.withoutTypeCard;
  typeCartStatus = EstatusTypeCard;
  subscription = new Subscription();
  isShowSelects = BooleanCons.true;
  isDialog = BooleanCons.false;
  labelByDefault = StringConst.empty;
  containerByDefault = StringConst.empty;
  labels = new Array<ICatalogs>();
  isShoppingCard = BooleanCons.false;
  isMyFavourites = BooleanCons.false;
  isdetailOrder = BooleanCons.false;
  isdetailOrderEdit = BooleanCons.false;
  messages = Messages;
  queryParamsCheck = StringConst.empty;
  callPlace = CallPlace.listShoppingCart;
  callPlaceEditOrder = CallPlace.detailOrderListEdit;
  isOrderResumer = BooleanCons.false;
  isActiveOrders = BooleanCons.false;
  isCardDisabled = BooleanCons.false;
  isTopProduct = BooleanCons.false;
  showDetailsButton = BooleanCons.true;
  isPendingOrders = BooleanCons.false;
  isPendingOrdersDialog = BooleanCons.false;
  isVisible = true;
  isEditable = false;
  position = 1;
  isMobile = false;
  isAdvisorRoles = false;
  typeDeleteOptions = TypeGeneralResponseOption;
  componentId = uuidv4();
  hoffmanTextFlag = BooleanCons.false;
  hoffmanText = StringConst.empty;
  showCostoPor = BooleanCons.false;
  constructor(
    private commonService: CommonService,
    private observableService: ObservableService,
    private localStorageService: LocalStorageService,
    private calculationService: CalculationService,
    private shoppingCartService: ShoppingCartService,
    private favoritesService: FavoritesService,
    private dialogService: DialogService
  ) { }
  ngAfterViewInit(): void {
    if (this.isLastItem) {
      this.viewReady.emit();
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.isMobile = event.target.innerWidth < 768;
  }

  favoriteChange(favoriteChange: ChangeFavorite): void {
    this.productCard.detailProduct.productAttributes[
      favoriteChange.indexAttribute
    ].isFavorite = favoriteChange.isFavorite;
  }
  ngOnInit(): void {
    const currentRole = this.localStorageService.getUserInRole();
    this.showCostoPor = this.showDiscount();
    this.isAdvisorRoles = currentRole === RolesString.advisor || currentRole === RolesString.adminPromo;
    this.isMobile = window.innerWidth < 768;
    this.productCard.detailProduct.costPerPieceDiscount = Number(
      (this.productCard.detailProduct.costPerPieceDiscount ?? 0).toFixed(4)
    );
    this.productCard.detailProduct.costPerPiece = Number(
      (this.productCard.detailProduct.costPerPiece ?? 0).toFixed(4)
    );
    this.isTopProduct = this.productCard.callPlace === CallPlace.myProducts;
    this.isShoppingCard =
      this.productCard.callPlace === CallPlace.listShoppingCart;
    this.isMyFavourites = this.productCard.callPlace === CallPlace.myFavourites;
    this.isdetailOrder =
      this.productCard.callPlace === CallPlace.detailOrderList;
    this.isShowSelects =
      this.productCard.detailProduct.isLine !== LineProductCons.yes;
    this.isDialog = this.productCard.callPlace === CallPlace.dialog;
    this.isActiveOrders = this.productCard.callPlace === CallPlace.activeOrders;
    this.isdetailOrderEdit =
      this.productCard.callPlace === CallPlace.detailOrderListEdit;
    this.isOrderResumer = this.productCard.callPlace === CallPlace.orderResume;
    this.isPendingOrdersDialog =
      this.productCard.callPlace === CallPlace.pendingOrdersDialog;
    this.showDetailsButton = !DontShowDetailButtonList.includes(
      this.productCard.callPlace
    );
    this.isPendingOrders =
      this.productCard.callPlace === CallPlace.pendingOrders;
    this.calculateProductPrices();
    this.labels = this.commonService.getLabelsByItemCode(
      this.localStorageService.getLabelsCatalog(),
      this.productCard.detailProduct.itemCode
    );
    this.productCard.detailProduct.productAttributes =
      this.commonService.getValidateLabels(
        this.productCard.detailProduct.productAttributes,
        this.labels,
        this.isShowSelects
      );
    this.subscription.add(
      this.observableService.getActiveContainerSelector().subscribe((res) => {
        if (this.componentId === res.componentId) {
          this.updateInfo(res);
        }
      })
    );
    this.subscription.add(
      this.observableService.getReloadProductCard().subscribe(() => {
        this.calculateProductPrices();
      })
    );
    this.hoffmanTextFlag = this.commonService.validateValidString(this.productCard.detailProduct.hoffmanText ?? '');
    this.hoffmanText = this.commonService.calculateTernary(this.hoffmanTextFlag, this.productCard.detailProduct.hoffmanText, '');
  }

  showDiscount(): boolean {
    let show = true;
    if (this.commonService.validateValidString(this.promoCode)) {
      show = this.showDiscountForCode();
      return show;
    } else {
      show = this.showDiscountForDiscount();
      return show;
    }
  }

  showDiscountForCode(): boolean {
    const show = this.commonService.validateOrValueList([
      !this.productCard.detailProduct.productAttributes.some((attribute) => attribute.invalidByLabel),
      this.commonService.xorTwoValues(
        this.productCard.detailProduct.productAttributes.every(attribute => attribute.invalidByLabel),
        !this.productCard.detailProduct.productAttributes.some(attribute => attribute.invalidByLabel))
    ]);
    return show;
  }
  showDiscountForDiscount(): boolean {
    const invalidLabels = this.productCard.detailProduct.productAttributes[0].invalidLabels;
    const show = this.commonService.validateOrValueList([
      !this.productCard.detailProduct.productAttributes.some(attribute => invalidLabels.includes(attribute.label)),
      this.productCard.detailProduct.productAttributes.every(attribute => invalidLabels.includes(attribute.label))
    ]);
    return show;
  }

  showErrorLabelMessage(attribute: ProductAttributes): boolean {
    return attribute.invalidLabels.includes(attribute.label);
  }

  getDeleteMessage(container: string): string {
    return `¿Desea eliminar el envase ${container} del producto ${this.productCard.detailProduct.itemCode}?`;
  }
  updateInfo(res: ContainerSelectorEstructor): void {
    if (res.action === ContainerSelectorActions.addContainer) {
      const attribute = new ProductAttributes();
      attribute.arriveDateContainer = res.data.arriveDateContainer;
      attribute.container = res.data.description;
      attribute.containerCost = res.data.price;
      attribute.containerCostDiscount = res.data.priceWithDiscount;
      attribute.containerHasMissing = res.data.containerHasMissing;
      attribute.containerTaxRate = res.data.taxRate;
      attribute.label = this.labels[0].description;
      attribute.quantity = NumberCons.one;
      attribute.originLabel = String(this.labels[0].description) ?? StringConst.empty;
      attribute.costPerPiece = this.productCard.detailProduct.costPerPiece;
      attribute.costPerPieceDiscount = this.productCard.detailProduct.productAttributes[0].costPerPieceDiscount;
      attribute.invalidLabels = this.productCard.detailProduct.productAttributes[0].invalidLabels;
      attribute.priceWithDiscount = this.productCard.detailProduct.productAttributes[0].priceWithDiscount;

      const newSize = this.productCard.detailProduct.productAttributes.push(attribute);
      this.calculateProductPrices();
      this.onChangeContainer(
        attribute,
        newSize - 1,
        StringConst.empty,
        true,
        true
      );
    } else {
      const containerToChange =
        res.product.productAttributes[res.containerIndex].container;
      this.productCard.detailProduct.productAttributes[
        res.containerIndex
      ].arriveDateContainer = res.data.arriveDateContainer;
      this.productCard.detailProduct.productAttributes[
        res.containerIndex
      ].container = res.data.description;
      this.productCard.detailProduct.productAttributes[
        res.containerIndex
      ].containerCost = res.data.price;
      this.productCard.detailProduct.productAttributes[
        res.containerIndex
      ].containerCostDiscount = res.data.priceWithDiscount;
      this.productCard.detailProduct.productAttributes[
        res.containerIndex
      ].containerHasMissing = res.data.containerHasMissing;
      this.productCard.detailProduct.productAttributes[
        res.containerIndex
      ].containerTaxRate = res.data.taxRate;
      this.calculateProductPrices();
      this.onChangeContainer(
        this.productCard.detailProduct.productAttributes[res.containerIndex],
        res.containerIndex,
        containerToChange,
        false,
        false
      );
    }
  }

  calculateProductPrices(): void {
    this.productCard.detailProduct = this.calculationService.calculateIProductPrices(this.productCard.detailProduct);
    const totalPieces =
      this.calculationService.calculateQuantityPiecesByProduct(
        this.productCard.detailProduct
      );
    this.productCard.detailProduct.utilityByProduct =
      this.calculationService.calculateAmountUtility(
        totalPieces,
        this.productCard.detailProduct.utilityByPiece
      );
    this.productCard.detailProduct.utilityPercentage =
      this.calculationService.calculateUtilitiesPercentage(
        this.productCard.detailProduct.displayPrices?.costPerPieceDiscount,
        this.productCard.detailProduct.priceToPublic
      );
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getPricesToAdd(): number[] {
    const pricesToReturn: number[] = [];
    this.productCard.detailProduct.productAttributes?.forEach((productAttribute) => {
      const price = productAttribute.invalidLabels?.includes(productAttribute.label)
        ? productAttribute.displayProductPrices.costPerPiece
        : productAttribute.displayProductPrices.costPerPieceDiscount;
      pricesToReturn.push(price);
    });
    return pricesToReturn;
  }

  newPieces(
    currentPieces: number | string,
    productAttributeIndex: number
  ): void {
    const pieces = this.commonService.calculateTernary(
      typeof currentPieces === 'string',
      0,
      currentPieces
    );
    if (this.productCard.callPlace === CallPlace.listShoppingCart) {
      this.updateProductService(
        this.productCard.detailProduct,
        Number(pieces),
        this.productCard.detailProduct.productAttributes[productAttributeIndex]
          .label,
        this.productCard.detailProduct.productAttributes[productAttributeIndex]
          .container,
        true,
        productAttributeIndex,
        StringConst.empty,
        false,
        false
      );
      return;
    }
    this.productCard.detailProduct.productAttributes[
      productAttributeIndex
    ].quantity = Number(pieces);
    this.validateLabelError(productAttributeIndex);
    this.calculateProductPrices();
    this.productCard.detailProduct.checkPieces = BooleanCons.true;
    const productBeforeChange = new PiecesChangeEmitter();
    productBeforeChange.productAttributeId = productAttributeIndex;
    productBeforeChange.productBeforeChange = this.productCard.detailProduct;
    this.productEmitter.emit(productBeforeChange);
    this.isCardDisabled = BooleanCons.false;
  }

  validateLabelError(attributeId: number): void {
    const minPieces = this.localStorageService.getMinPiecesQuantity();
    const hasError = this.productCard.detailProduct.productAttributes[attributeId].labelError;
    const displayError = this.commonService.validateAndValue([
      hasError,
      this.productCard.detailProduct.productAttributes[attributeId].quantity < minPieces,
      this.productCard.detailProduct.productAttributes[attributeId].label.toUpperCase() === ValidationLabel]);
    const labelError = this.commonService.calculateTernary(displayError, true, false);
    this.productCard.detailProduct.productAttributes[attributeId].labelError = labelError;
  }
  updateShoppingCounter(): void {
    this.observableService.setTotalproducts();
  }

  updateProductLocal(
    currentPieces: number,
    label: string,
    container: string,
    productUpdated: ProductUpdatedFavourite[],
    needsFavorite: boolean,
    productAttributeIndex: number
  ): void {
    const productBeforeChange = new PiecesChangeEmitter();
    productBeforeChange.productAttributeId = productAttributeIndex;
    productBeforeChange.productBeforeChange = this.productCard.detailProduct;
    this.updateShoppingCounter();
    this.productCard.detailProduct.productAttributes[
      productAttributeIndex
    ].label = label;
    this.productCard.detailProduct.productAttributes[
      productAttributeIndex
    ].container = container;
    this.productCard.detailProduct.productAttributes[
      productAttributeIndex
    ].quantity = currentPieces;
    this.validateLabelError(productAttributeIndex);
    this.calculateProductPrices();
    if (needsFavorite) {
      const favorite =
        this.productCard.detailProduct.productAttributes[productAttributeIndex]
          .isFavorite;
      this.productCard.detailProduct.productAttributes[
        productAttributeIndex
      ].isFavorite = this.commonService.calculateTernary(
        productUpdated.length > 0,
        productUpdated[0].isFavorite ?? false,
        favorite
      );
    }
    const data = this.commonService.getTypeReloadShoppingCar(this.index, this.typeCart);
    this.observableService.setReloadShoppingCar(data);
    this.productEmitter.emit(productBeforeChange);
  }

  updateProductService(
    product: IProducts,
    currentPieces: number,
    label: string,
    container: string,
    currentPiecesChanged: boolean = false,
    productAttributeIndex: number,
    lastContainer: string,
    needSumQuantity: boolean,
    needCalculatePrices: boolean
  ): void {
    const productToUpdate = this.commonService.getProductToUpdateObj(
      product,
      currentPieces,
      container,
      label,
      lastContainer,
      needSumQuantity,
      needCalculatePrices,
      this.typeCart,
      this.localStorageService.getPriceList()
    );
    productToUpdate.needsFavorite = !currentPiecesChanged;
    this.shoppingCartService.updateProduct(productToUpdate).subscribe((res) => {
      this.updateProductLocal(
        currentPieces,
        label,
        container,
        res.response ?? [],
        productToUpdate.needsFavorite,
        productAttributeIndex
      );
    });
  }

  changeContainer(
    productAttributes: ProductAttributes,
    attributeIndex: number
  ): void {
    const container = new Container();
    container.description =
      this.productCard.detailProduct.productAttributes[
        attributeIndex
      ].container;
    this.dialogService.openContainerSelector(ContainerSelectorComponent, {
      place: this.productCard.callPlace,
      data: container,
      product: JSON.parse(JSON.stringify(this.productCard.detailProduct)),
      productIndex: this.index,
      containerIndex: attributeIndex,
      action: ContainerSelectorActions.changeContainer,
      containersInProduct: this.productCard.detailProduct.productAttributes.map(
        (product) => product.container
      ),
      componentId: this.componentId,
      showMissingMesages: true
    });
  }

  addContainer(): void {
    this.dialogService.openContainerSelector(ContainerSelectorComponent, {
      place: this.productCard.callPlace,
      data: new Container(),
      product: JSON.parse(JSON.stringify(this.productCard.detailProduct)),
      productIndex: this.index,
      containerIndex: 0,
      action: ContainerSelectorActions.addContainer,
      containersInProduct: this.productCard.detailProduct.productAttributes.map(
        (product) => product.container
      ),
      componentId: this.componentId,
      showMissingMesages: true
    });
  }

  onChangeContainer(
    attribute: ProductAttributes,
    indexAttribute: number,
    lastContainer: string,
    needSumQuantity: boolean,
    newContainer: boolean
  ): void {
    attribute.containerError = BooleanCons.false;
    if (this.productCard.callPlace === CallPlace.listShoppingCart) {
      this.updateProductService(
        this.productCard.detailProduct,
        attribute.quantity,
        attribute.label,
        attribute.container,
        false,
        indexAttribute,
        lastContainer,
        needSumQuantity,
        newContainer
      );
    }
    if (
      this.commonService.validateOrValue(
        this.productCard.callPlace === CallPlace.detailOrderListEdit,
        this.validateFavorite
      )
    ) {
      this.consultProduct(indexAttribute);
    }
  }

  updateQueryParams(itemCode: string, label: string, container: string): void {
    this.queryParamsCheck = `?cardCode=${this.localStorageService.getCardCodeGeneral()}&itemCode=${itemCode}&label=${label}&container=${container}`;
  }
  onChangeLabel(label: string, productAttributeIndex: number): void {
    this.productCard.detailProduct.productAttributes[
      productAttributeIndex
    ].labelError = false;
    if (this.productCard.callPlace === CallPlace.listShoppingCart) {
      const container = this.commonService.calculateTernary(
        this.productCard.detailProduct.isLine === LineProductCons.yes,
        StringConst.empty,
        this.productCard.detailProduct.productAttributes[productAttributeIndex]
          .container
      );

      this.updateProductService(
        this.productCard.detailProduct,
        this.productCard.detailProduct.productAttributes[productAttributeIndex]
          .quantity,
        label,
        container,
        false,
        productAttributeIndex,
        StringConst.empty,
        false,
        false
      );
    }
    this.productCard.detailProduct.productAttributes[
      productAttributeIndex
    ].label = label;
    this.calculateProductPrices();
    if (
      this.commonService.validateOrValue(
        this.productCard.callPlace === CallPlace.detailOrderListEdit,
        this.validateFavorite
      )
    ) {
      this.consultProduct(productAttributeIndex);
    }
  }

  consultProduct(productAttributeIndex: number): void {
    this.updateQueryParams(
      this.productCard.detailProduct.itemCode,
      this.productCard.detailProduct.productAttributes[productAttributeIndex]
        .label,
      this.productCard.detailProduct.productAttributes[productAttributeIndex]
        .container
    );
    this.favoritesService.checkFavorite(this.queryParamsCheck).subscribe(
      (res) => {
        this.checkIsProductFavorite(res.response, productAttributeIndex);
      },
      (error) => {
        this.productEmitter.emit(new PiecesChangeEmitter());
      }
    );
  }

  checkIsProductFavorite(
    listProduct: FavoriteChange[],
    productAttributeIndex: number
  ): void {
    const index = listProduct.findIndex(
      (productSearched) =>
        productSearched.itemCode === this.productCard.detailProduct.itemCode
    );
    this.productCard.detailProduct.productAttributes[
      productAttributeIndex
    ].isFavorite = index !== -1;
    const data = new PiecesChangeEmitter();
    data.productAttributeId = productAttributeIndex;
    this.productEmitter.emit(data);
  }

  deleteProductListShoppingCart(value: boolean): void {
    const data = this.commonService.getTypeReloadShoppingCar(this.index, this.typeCart);
    this.observableService.setReloadShoppingCar(data);
  }

  deleteProductToRepurchase(): void {
    this.observableService.setDeleteProductDetalleOrder(this.index);
  }

  deleteProductAttributeToRepurchase(attributeId: number): void {
    this.attributeDeleteEmitter.emit(attributeId);
  }

  openUtilitiesCalculator(): void {
    const dialogConfig = new MatDialogConfig();
    const dialogContent = new UtilitiesCalculator();
    dialogContent.itemCode = this.productCard.detailProduct.itemCode;
    dialogContent.description = this.productCard.detailProduct.description;
    dialogContent.costPerPiece =
      this.productCard.detailProduct.displayPrices.costPerPieceDiscount;
    dialogContent.costThePublic = this.productCard.detailProduct.priceToPublic;
    dialogContent.utility = 0;
    dialogContent.oldUtilityAmount =
      this.productCard.detailProduct.utilityByProduct;
    dialogContent.utilityPercentage =
      this.productCard.detailProduct.utilityPercentage;
    dialogContent.quantity = this.calculationService.getTotalPiecesByProduct(
      this.productCard.detailProduct
    );
    dialogConfig.data = dialogContent;
    const dialogRef = this.dialogService.displayDialog(
      UtilitiesCalculatorComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((dataUtilities) => {
      if (dataUtilities !== undefined) {
        this.productCard.detailProduct.utilityPercentage =
          dataUtilities.utilityPercentage;
        this.productCard.detailProduct.utilityByPiece = dataUtilities.utility;
        this.productCard.detailProduct.utilityByProduct =
          dataUtilities.newUtilityAmount;
        this.productCard.detailProduct.priceToPublic =
          dataUtilities.costThePublic;
        const updateProductUtilities = new UpdateProductUtility();
        updateProductUtilities.itemCode =
          this.productCard.detailProduct.itemCode;
        updateProductUtilities.priceToPublic =
          this.productCard.detailProduct.priceToPublic;
        this.shoppingCartService
          .updateProductUtilities(
            updateProductUtilities,
            this.localStorageService.getCardCodeGeneral()
          )
          .subscribe(() => {
            this.productEmitterUtilitiesCalculator.emit(dataUtilities);
          });
      }
    });
  }
}
